import React from 'react';
import styled from 'styled-components';
import FeatureCard from './FeatureCard';
import { FaStar, FaUserAlt, FaChartPie, FaCog, FaLayerGroup, FaComments } from 'react-icons/fa';

const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 20px;
  background-color:#062c3f;
`;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  max-width: 1120px;
   font-family: "Poppins", system-ui;
  width: 100%;
  justify-content: space-between; /* Adjusted for better spacing between cards */
`;

const SectionTitle = styled.h2`
  font-size: 3em;
  color:#00cbf1;
  font-weight: 700;
  margin: 10px 0 40px 0;
  text-align: left;
  width: 100%;

  span {
    color: #f0faff;
  }

  @media (max-width: 768px) {
    font-size: 2.2em;
  }

  @media (max-width: 480px) {
    font-size: 2em;
  }
`;

const features = [
  { icon: <FaStar />, title: 'Expert Workforce & Best Practices', description: 'Highly experienced professionals employing proven methodologies, best practices, and tools for rapid solution deployment.', iconColor: '#FFD700' },
  { icon: <FaUserAlt />, title: 'Specialized Solutions & Strategic Alignment', description: 'Tailored PLM packages for specific business needs, aligned with your business strategies.', iconColor: '#FF6347' },
  { icon: <FaChartPie />, title: 'Business Integration & Value Services', description: 'Comprehensive services to maximize PLM value through right business and technical alignment.', iconColor: '#4682B4' },
  { icon: <FaCog />, title: 'Innovative Approach & Collaborative Model', description: 'Win-win partnerships to address diverse business challenges with innovative solutions and engagements.', iconColor: '#32CD32' },
  { icon: <FaLayerGroup />, title: 'Technology Hub & Proven Delivery', description: 'Reduced go live periods with enhanced ROI leveraging cutting edge technology and project management expertise.', iconColor: '#8A2BE2' },
  { icon: <FaComments />, title: 'Strategic Consulting', description: 'Successful value added PLM implementation with the help of strategic business consulting and value delivery.', iconColor: '#FF4500' }
];

const FeaturesSection = () => (
  <Section>
    <SectionTitle className='container'>Why <span>NexTech?</span></SectionTitle>
    
    <Container>
      {features.map((feature, index) => (
        <FeatureCard key={index} icon={feature.icon} title={feature.title} description={feature.description} iconColor={feature.iconColor} />
      ))}
    </Container>
  </Section>
);

export default FeaturesSection;
